














































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { VoteDocument, JinroPlayerDocument } from "../../services/datatypes";
import { getVoteRankingTopList } from "../../utils/utils";

interface VotesNameObj {
  fromPlayerName: string;
  toPlayerName: string;
}

@Component({})
export default class SelectResult extends Vue {
  @Prop() readonly votes!: Array<VoteDocument>;
  @Prop() readonly votablePlayers!: Array<JinroPlayerDocument>;
  selectedOption = "";
  @Prop() readonly selectResultLabel!: string;

  get votesNameList(): Array<VotesNameObj> {
    const lists: Array<VoteDocument> = this.votes;
    return lists.map(list => {
      return {
        fromPlayerName: list.fromPlayer.playerName,
        toPlayerName: list.toPlayer.playerName
      };
    });
  }

  get notVotedPlayers(): Array<JinroPlayerDocument> {
    const votablePlayerIds = this.votes.map(vote => {
      return vote.fromPlayer.id;
    });
    const notVotedPlayers = this.votablePlayers.filter(player => {
      return !votablePlayerIds.includes(player.id);
    });
    return notVotedPlayers;
  }

  get voteRankingTopList(): Array<{
    index: number;
    count: number;
    playerNames: Array<string>;
  }> {
    const topN = 3;
    return getVoteRankingTopList(this.votes, topN);
  }
}
